import cn from "classnames"

import { Badge, Flex } from "@/atoms"
import { IconTag } from "@/molecules/IconTag"

import styles from "./IncidentTag.module.scss"

import type { IncidentTagProps } from "./IncidentTag.types"

export const IncidentTag = (props: IncidentTagProps) => {
  const { icon, count, text, palette = "neutral" } = props
  const classes = { tag: cn(styles.tag, styles[`${palette}TagThemeKs`]) }
  const nextProps = { classes, icon, iconSize: "sm" as const }

  if (icon)
    return (
      <IconTag
        text={<span className={styles.value}>{text}</span>}
        {...nextProps}
      />
    )

  const { label } = props
  const isCount = count ?? false

  return (
    <IconTag
      text={
        <Flex gap={isCount ? 8 : 4}>
          <span className={styles.label}>{label}</span>
          {isCount && (
            <Badge count={count} color="#F0F0F0" className={styles.count} />
          )}
          {!!text && <span className={styles.value}>{text}</span>}
        </Flex>
      }
      {...nextProps}
    />
  )
}
